import { render, staticRenderFns } from "./jraAssessRiskRegisterPop.vue?vue&type=template&id=e55e82cc"
import script from "./jraAssessRiskRegisterPop.vue?vue&type=script&lang=js"
export * from "./jraAssessRiskRegisterPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e55e82cc')) {
      api.createRecord('e55e82cc', component.options)
    } else {
      api.reload('e55e82cc', component.options)
    }
    module.hot.accept("./jraAssessRiskRegisterPop.vue?vue&type=template&id=e55e82cc", function () {
      api.rerender('e55e82cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskRegister/jraAssessRiskRegisterPop.vue"
export default component.exports